import {getResource} from "@/api/CommonApi";
import {ref} from "vue";


/**
 * 夹杂资源的类
 * @author wwy
 */
export default class LoadResource{
    // 资源ID
    resId;
    /** 是否加载内容 */
    fetchContent;
    /** 是否正在加载 */
    loading = ref(false);
    /** 服务端响应内容 */
    resource = ref({
        firstItem:{}
    });


    constructor(id,fetchContent) {
        this.init(id,fetchContent)
    }

    /**
     * 初始化
     * @param id 资源ID
     * @param fetchContent 是否加载内容
     */
    init(id,fetchContent){
        this.resId = id
        this.fetchContent = fetchContent
        return this.loadResource()
    }

    /**
     * 加载资源数据
     */
    loadResource(){
        this.loading.value = true
        return getResource(this.resId,{fetchContent:this.fetchContent}).then(res => {
            this.resource.value = res.result
            return res.result
        }).finally(() => {
            this.loading.value = false
        })
    }

}
